import { createFileRoute } from "@tanstack/react-router";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { ChallengeFriendButton } from "@/components/challenges/ChallengeFriendButton";
import { MyChallengesBoard } from "@/components/challenges/MyChallengesBoard";

export const Route = createFileRoute("/retos")({
  head: () => ({
    meta: [
      { title: "Retos · VerseSport" },
      {
        name: "description",
        content:
          "Desafía a tus amigos en duelos privados de predicciones durante el Mundial 2026.",
      },
    ],
  }),
  component: RetosPage,
});

function RetosPage() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-background">
      <RouteTopBar fallback="/" />
      <div className="mx-auto w-full max-w-2xl space-y-4 px-3 py-6 sm:px-6">
        <header className="rounded-2xl border border-border bg-gradient-to-br from-[oklch(0.58_0.24_27)]/15 via-background to-background p-4">
          <h1 className="text-lg font-black">⚔️ Friend vs Friend</h1>
          <p className="mt-1 text-[12px] text-muted-foreground">
            Reta a un amigo. Quien acierte más predicciones en 24 horas gana <strong className="text-foreground">+100 XP</strong> y el badge <strong className="text-foreground">FRIEND CHAMPION</strong>.
          </p>
          <div className="mt-3">
            <ChallengeFriendButton />
          </div>
        </header>
        <MyChallengesBoard />
      </div>
    </main>
  );
}